import React, { useCallback } from 'react';
import UDMainLayout from '../../../ud-ui/layout/main';
import UDHeaderTitle from '../../../ud-ui/components/header-title';
import UDText from '../../../ud-ui/components/text';
import { OrganizerForm } from '../../../organizer/ui/components/organizer-form';
import { useOrganizer } from '../../../organizer/ui/hooks/useOrganizer';
import { OrganizerUpsertPayload } from '../../../organizer/domain/interfaces/OrganizerUpsertPayload';
import { useDispatch } from 'react-redux';
import { upsertOrganizer } from '../../../organizer/store/actions';
import { useAuth } from '../../../auth/ui/hooks/useAuth';
import { UpsertOrganizerInput } from '../../../organizer/domain/interfaces/UpsertOrganizerInput';

const SettingsPage = () => {
  const { user } = useAuth();
  const { isLoading, info } = useOrganizer();
  const dispatch = useDispatch();

  const values = info || undefined;
  const handleOrganizerSubmit = useCallback((data: OrganizerUpsertPayload) => {
    const { logo, ...restData } = data;

    const params = {
      ...restData,
      adminUserId: user!.id,
      sportType: data.sportType.toString().toUpperCase(),
      logo: logo && logo.length ? logo[0] : undefined,
    } as UpsertOrganizerInput;

    dispatch(upsertOrganizer(params));
  }, [dispatch, user]);

  return (
    <UDMainLayout
      headerContent={
        <>
          <UDHeaderTitle>Настройки</UDHeaderTitle>
        </>
      }
    >
      <div className='container py-6'>
        <UDText type="headline" className="mr-10">
          Информация об организаторе
        </UDText>
      </div>
      <div className="container d-flex align-items-center bb-1" />
      <div className="container py-6">
        {isLoading
          ? ('loading...')
          : (
            <OrganizerForm
              initialValues={values}
              onSubmit={handleOrganizerSubmit}
            />
          )
        }

      </div>
    </UDMainLayout>
  );
};

export default SettingsPage;
